import styled, { css } from 'styled-components'

interface StepContainerProps {
  index: number
  activeStep: number
}

export const Steps = styled(({ insideModal, ...rest }) => <div {...rest} />)`
  ${({ theme, insideModal }) => css`
    display: flex;
    justify-content: center;
    gap: 12px;

    ${insideModal &&
    css`
      background: ${theme.colors.backgroundColor};
      width: calc(100% + 3rem);
      margin: -1.5rem;
      padding: 20px;
      border-bottom: 1px solid #e6e8eb;
    `}
  `}
`

export const Content = styled.div`
  margin-top: 40px;
`

export const StepContainer = styled.div<StepContainerProps>`
  ${({ index, activeStep, theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;

    i.icon {
      margin-left: 28px !important;
      font-size: 10px !important;
    }

    span {
      white-space: nowrap;
      position: relative;
      color: ${activeStep === index ? theme.primaryFontColor : '#838792'};

      ${activeStep === index &&
      css`
        :after {
          content: '';
          border-bottom: 2px solid ${theme.primaryColor};
          position: absolute;
          bottom: -20px;
          left: 0;
          width: 100%;
        }
      `}
    }
  `}
`
